/* eslint-disable */
import config from '../../config'
import styles from './index.module.scss'
import Breadcrumb from '../../components/core/breadcrumb'
import { FormButton, Button } from '../../components/core/button'
import { GeneralInput } from '../../components/core/input'
import { useState, useRef, useContext, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import {
  Account,
  LangArrows,
  Map,
  Education,
  Plus,
  Language,
  Work,
  Close,
  Cancel,
} from '../../icons'
import Helper from '../../utils/Helper'
import { PageContext } from '../../context/PageContextProvider'
import SelectsAPI from '../../api/selects'
import VacancyAPI from '../../api/vacancy'
import CareersAPI from '../../api/careers'
import { Module } from '../../components/core/module'
import Loading from '../../components/pages/loading'
import translate from '../../utils/translate.json'

const VacancyApply = ({ className }) => {
  const { language } = useContext(PageContext)
  const [load, setLoad] = useState(false)
  const [data, setData] = useState([])
  const [year, setyear] = useState(translate.year[language])
  const [choose, setChoose] = useState(translate.choose[language])
  const [verify, setVerify] = useState(null)
  const [error, setError] = useState(null)
  const [vacancy, setVacancy] = useState(null)
  const [module, setModule] = useState(false)
  const [cvFile, setCvFile] = useState(null)
  const [dragActive, setDragActive] = useState(false)
  let { id } = useParams()
  const [crumbs, setCrumbs] = useState([])

  const [skillsList, setSkillsList] = useState([
    { id: 1, name: '', level: 'Orta', bool: false }
  ])
  const skillLevels = [
    { AZ: 'Başlanğıc', ENG: 'Beginner', RU: 'Начальный' },
    { AZ: 'Orta', ENG: 'Intermediate', RU: 'Средний' },
    { AZ: 'Yaxşı', ENG: 'Good', RU: 'Хороший' },
    { AZ: 'Əla', ENG: 'Excellent', RU: 'Отличный' },
    { AZ: 'Mütəxəssis', ENG: 'Expert', RU: 'Эксперт' },
  ]
  const addSkill = () => {
    setSkillsList((prev) => [
      ...prev,
      { id: Date.now(), name: '', level: 'Orta', bool: false }
    ])
  }
  const removeSkill = (skillId) => {
    if (skillsList.length === 1) {
      setSkillsList([{ id: Date.now(), name: '', level: 'Orta', bool: false }])
    } else {
      setSkillsList((prev) => prev.filter((s) => s.id !== skillId))
    }
  }
  const updateSkillName = (skillId, val) => {
    setSkillsList((prev) => prev.map((s) => (s.id === skillId ? { ...s, name: val } : s)))
  }
  const updateSkillLevel = (skillId, val) => {
    setSkillsList((prev) => prev.map((s) => (s.id === skillId ? { ...s, level: val, bool: false } : s)))
  }
  const toggleSkillDropdown = (skillId) => {
    setSkillsList((prev) =>
      prev.map((s) => (s.id === skillId ? { ...s, bool: !s.bool } : { ...s, bool: false }))
    )
  }
  useEffect(() => {
    (async () => {

    const { data: datum } = await SelectsAPI.getGender()
    await setData(datum)
    let data = { title: { AZ: 'Müraciət Formu', ENG: 'Application Form', RU: 'Форма заявки' } };
    try {
      const res = await CareersAPI.getVacancyById(id);
      if (res && res.data) data = res.data;
    } catch(e) {}
    await setCrumbs([
      {
        link: '/',
        text: {
          AZ: 'Ana Səhifə',
          ENG: 'Home',
          RU: 'Главная страница',
        },
      },
      {
        link: '/careers',
        text: {
          AZ: 'Karyera',
          ENG: 'Careers',
          RU: 'Карьера',
        },
      },
      {
        link: '#',
        text: {
          AZ: 'Vakansiya',
          ENG: 'Vacancy',
          RU: 'Вакансия',
        },
      },
      {
        link: `/vacancy/${id}`,
        text: data.title,
      },
      {
        link: '#',
        text: {
          AZ: 'Müraciət edin',
          ENG: 'Apply',
          RU: 'Подать заявление',
        },
      },
    ])
    await setVacancy(data.title)
    await setLoad(true)
  
    })();
  }, [])

  function generateGraduation() {
    var max = new Date().getFullYear() + 10
    var min = max - 75
    var years = []

    for (var i = max; i >= min; i--) {
      years.push(i)
    }
    return years
  }
  const eduRef = useRef(null),
    [isVisible4, setIsVisible4] = useState(false),
    [gender, setGender] = useState(translate.choose[language]),
    [graduation1, setGraduation1] = useState(translate.year[language]),
    [graduation2, setGraduation2] = useState(translate.year[language]),
    [graduation3, setGraduation3] = useState(translate.year[language]),
    [graduation4, setGraduation4] = useState(translate.year[language]),
    [graduation5, setGraduation5] = useState(translate.year[language]),
    [graduation6, setGraduation6] = useState(translate.year[language]),
    [graduation7, setGraduation7] = useState(translate.year[language]),
    [graduation8, setGraduation8] = useState(translate.year[language]),
    [graduation9, setGraduation9] = useState(translate.year[language]),
    [graduation10, setGraduation10] = useState(translate.year[language]),
    [edu1, setEdu1] = useState(false),
    [edu2, setEdu2] = useState(false),
    [edu3, setEdu3] = useState(false),
    [edu4, setEdu4] = useState(false),
    [edu5, setEdu5] = useState(false),
    [edu6, setEdu6] = useState(false),
    [edu7, setEdu7] = useState(false),
    [edu8, setEdu8] = useState(false),
    [edu9, setEdu9] = useState(false),
    [edu10, setEdu10] = useState(false)

  const [booledu2, setBoolEdu2] = useState(false),
    [booledu3, setBoolEdu3] = useState(false),
    [booledu4, setBoolEdu4] = useState(false),
    [booledu5, setBoolEdu5] = useState(false),
    [booledu6, setBoolEdu6] = useState(false),
    [booledu7, setBoolEdu7] = useState(false),
    [booledu8, setBoolEdu8] = useState(false),
    [booledu9, setBoolEdu9] = useState(false),
    [booledu10, setBoolEdu10] = useState(false)

  const [boolTel2, setBoolTel2] = useState(false),
    [boolTel3, setBoolTel3] = useState(false),
    [boolTel4, setBoolTel4] = useState(false),
    [boolTel5, setBoolTel5] = useState(false),
    [boolTel6, setBoolTel6] = useState(false),
    [boolTel7, setBoolTel7] = useState(false),
    [boolTel8, setBoolTel8] = useState(false),
    [boolTel9, setBoolTel9] = useState(false),
    [boolTel10, setBoolTel10] = useState(false)

  const [reading1, setReading1] = useState(translate.choose[language]),
    [reading2, setReading2] = useState(translate.choose[language]),
    [reading3, setReading3] = useState(translate.choose[language]),
    [reading4, setReading4] = useState(translate.choose[language]),
    [reading5, setReading5] = useState(translate.choose[language]),
    [reading6, setReading6] = useState(translate.choose[language]),
    [reading7, setReading7] = useState(translate.choose[language]),
    [reading8, setReading8] = useState(translate.choose[language]),
    [reading9, setReading9] = useState(translate.choose[language]),
    [reading10, setReading10] = useState(translate.choose[language])
  const [readBool1, setreadBool1] = useState(false),
    [readBool2, setreadBool2] = useState(false),
    [readBool3, setreadBool3] = useState(false),
    [readBool4, setreadBool4] = useState(false),
    [readBool5, setreadBool5] = useState(false),
    [readBool6, setreadBool6] = useState(false),
    [readBool7, setreadBool7] = useState(false),
    [readBool8, setreadBool8] = useState(false),
    [readBool9, setreadBool9] = useState(false),
    [readBool10, setreadBool10] = useState(false)

  const [writing1, setwriting1] = useState(translate.choose[language])
  const [writing2, setwriting2] = useState(translate.choose[language])
  const [writing3, setwriting3] = useState(translate.choose[language])
  const [writing4, setwriting4] = useState(translate.choose[language])
  const [writing5, setwriting5] = useState(translate.choose[language])
  const [writing6, setwriting6] = useState(translate.choose[language])
  const [writing7, setwriting7] = useState(translate.choose[language])
  const [writing8, setwriting8] = useState(translate.choose[language])
  const [writing9, setwriting9] = useState(translate.choose[language])
  const [writing10, setwriting10] = useState(translate.choose[language])
  const [writingBool1, setwritingBool1] = useState(false)
  const [writingBool2, setwritingBool2] = useState(false)
  const [writingBool3, setwritingBool3] = useState(false)
  const [writingBool4, setwritingBool4] = useState(false)
  const [writingBool5, setwritingBool5] = useState(false)
  const [writingBool6, setwritingBool6] = useState(false)
  const [writingBool7, setwritingBool7] = useState(false)
  const [writingBool8, setwritingBool8] = useState(false)
  const [writingBool9, setwritingBool9] = useState(false)
  const [writingBool10, setwritingBool10] = useState(false)

  const [speaking1, setspeaking1] = useState(translate.choose[language])
  const [speaking2, setspeaking2] = useState(translate.choose[language])
  const [speaking3, setspeaking3] = useState(translate.choose[language])
  const [speaking4, setspeaking4] = useState(translate.choose[language])
  const [speaking5, setspeaking5] = useState(translate.choose[language])
  const [speaking6, setspeaking6] = useState(translate.choose[language])
  const [speaking7, setspeaking7] = useState(translate.choose[language])
  const [speaking8, setspeaking8] = useState(translate.choose[language])
  const [speaking9, setspeaking9] = useState(translate.choose[language])
  const [speaking10, setspeaking10] = useState(translate.choose[language])
  const [speakingBool1, setspeakingBool1] = useState(false)
  const [speakingBool2, setspeakingBool2] = useState(false)
  const [speakingBool3, setspeakingBool3] = useState(false)
  const [speakingBool4, setspeakingBool4] = useState(false)
  const [speakingBool5, setspeakingBool5] = useState(false)
  const [speakingBool6, setspeakingBool6] = useState(false)
  const [speakingBool7, setspeakingBool7] = useState(false)
  const [speakingBool8, setspeakingBool8] = useState(false)
  const [speakingBool9, setspeakingBool9] = useState(false)
  const [speakingBool10, setspeakingBool10] = useState(false)

  const [listening1, setlistening1] = useState(translate.choose[language])
  const [listening2, setlistening2] = useState(translate.choose[language])
  const [listening3, setlistening3] = useState(translate.choose[language])
  const [listening4, setlistening4] = useState(translate.choose[language])
  const [listening5, setlistening5] = useState(translate.choose[language])
  const [listening6, setlistening6] = useState(translate.choose[language])
  const [listening7, setlistening7] = useState(translate.choose[language])
  const [listening8, setlistening8] = useState(translate.choose[language])
  const [listening9, setlistening9] = useState(translate.choose[language])
  const [listening10, setlistening10] = useState(translate.choose[language])
  const [listeningBool1, setlisteningBool1] = useState(false)
  const [listeningBool2, setlisteningBool2] = useState(false)
  const [listeningBool3, setlisteningBool3] = useState(false)
  const [listeningBool4, setlisteningBool4] = useState(false)
  const [listeningBool5, setlisteningBool5] = useState(false)
  const [listeningBool6, setlisteningBool6] = useState(false)
  const [listeningBool7, setlisteningBool7] = useState(false)
  const [listeningBool8, setlisteningBool8] = useState(false)
  const [listeningBool9, setlisteningBool9] = useState(false)
  const [listeningBool10, setlisteningBool10] = useState(false)

  const [boollang2, setBoollang2] = useState(false)
  const [boollang3, setBoollang3] = useState(false)
  const [boollang4, setBoollang4] = useState(false)
  const [boollang5, setBoollang5] = useState(false)
  const [boollang6, setBoollang6] = useState(false)
  const [boollang7, setBoollang7] = useState(false)
  const [boollang8, setBoollang8] = useState(false)
  const [boollang9, setBoollang9] = useState(false)
  const [boollang10, setBoollang10] = useState(false)

  const [selectedImage, setSelectedImage] = useState(null)
  const [selectedFile, setSelectedFile] = useState(null)
  const graduations = generateGraduation()
  const percents = [
    'Ana dili (Native)',
    'Əla (C1 - C2)',
    'Yaxşı (B2)',
    'Orta (B1)',
    'Başlanğıc (A1 - A2)',
  ]
  const addEdu = () => {
    if (!booledu2) {
      setBoolEdu2(true)
    } else if (!booledu3) {
      setBoolEdu3(true)
    } else if (!booledu4) {
      setBoolEdu4(true)
    } else if (!booledu5) {
      setBoolEdu5(true)
    } else if (!booledu6) {
      setBoolEdu6(true)
    } else if (!booledu7) {
      setBoolEdu7(true)
    } else if (!booledu8) {
      setBoolEdu8(true)
    } else if (!booledu9) {
      setBoolEdu9(true)
    } else if (!booledu10) {
      setBoolEdu10(true)
    }
  }
  const addTel = () => {
    if (!boolTel2) {
      setBoolTel2(true)
    } else if (!boolTel3) {
      setBoolTel3(true)
    } else if (!boolTel4) {
      setBoolTel4(true)
    } else if (!boolTel5) {
      setBoolTel5(true)
    } else if (!boolTel6) {
      setBoolTel6(true)
    } else if (!boolTel7) {
      setBoolTel7(true)
    } else if (!boolTel8) {
      setBoolTel8(true)
    } else if (!boolTel9) {
      setBoolTel9(true)
    } else if (!boolTel10) {
      setBoolTel10(true)
    }
  }
  const addLang = () => {
    if (!boollang2) {
      setBoollang2(true)
    } else if (!boollang3) {
      setBoollang3(true)
    } else if (!boollang4) {
      setBoollang4(true)
    } else if (!boollang5) {
      setBoollang5(true)
    } else if (!boollang6) {
      setBoollang6(true)
    } else if (!boollang7) {
      setBoollang7(true)
    } else if (!boollang8) {
      setBoollang8(true)
    } else if (!boollang9) {
      setBoollang9(true)
    } else if (!boollang10) {
      setBoollang10(true)
    }
  }
  const sendAppeal = async () => {
    const vacancy_id = id
    const vacancy_name = vacancy['AZ']
    const fullname = document.querySelector('#vacancy-fullname').value.trim()
    if (fullname === '') {
      alert(translate.alert[language])
      console.log('alerttt')
      return
    }
    const birth = document.querySelector('#vacancy-date').value.trim()
    if (birth === '') {
      alert(translate.alert[language])
      console.log('alerttt')
      return
    }
    if (gender === choose) {
      alert(translate.alert[language])
      console.log('alerttt')
      return
    }
    let phones = []
    const phone1 = document.querySelector('#vacancy-phone1').value.trim()
    if (phone1 === '') {
      alert(translate.alert[language])
      console.log('alerttt')
      return
    }
    if (
      !/^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/.test(
        phone1,
      )
    ) {
      alert(translate.alert_phone[language])
      return
    }
    const phone2 = boolTel2
      ? document.querySelector('#vacancy-phone2')?.value.trim()
      : ''
    if (
      phone2 !== '' &&
      !/^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/.test(
        phone2,
      )
    ) {
      alert(translate.alert_phone[language])
      return
    }
    const phone3 = boolTel3
      ? document.querySelector('#vacancy-phone3')?.value.trim()
      : ''
    if (
      phone3 !== '' &&
      !/^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/.test(
        phone3,
      )
    ) {
      alert(translate.alert_phone[language])
      return
    }
    const phone4 = boolTel4
      ? document.querySelector('#vacancy-phone4')?.value.trim()
      : ''
    if (
      phone4 !== '' &&
      !/^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/.test(
        phone4,
      )
    ) {
      alert(translate.alert_phone[language])
      return
    }
    const phone5 = boolTel5
      ? document.querySelector('#vacancy-phone5')?.value.trim()
      : ''
    if (
      phone5 !== '' &&
      !/^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/.test(
        phone5,
      )
    ) {
      alert(translate.alert_phone[language])
      return
    }
    const phone6 = boolTel6
      ? document.querySelector('#vacancy-phone6')?.value.trim()
      : ''
    if (
      phone6 !== '' &&
      !/^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/.test(
        phone6,
      )
    ) {
      alert(translate.alert_phone[language])
      return
    }
    const phone7 = boolTel7
      ? document.querySelector('#vacancy-phone7')?.value.trim()
      : ''
    if (
      phone7 !== '' &&
      !/^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/.test(
        phone7,
      )
    ) {
      alert(translate.alert_phone[language])
      return
    }
    const phone8 = boolTel8
      ? document.querySelector('#vacancy-phone8')?.value.trim()
      : ''
    if (
      phone8 !== '' &&
      !/^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/.test(
        phone8,
      )
    ) {
      alert(translate.alert_phone[language])
      return
    }
    const phone9 = boolTel9
      ? document.querySelector('#vacancy-phone9')?.value.trim()
      : ''
    if (
      phone9 !== '' &&
      !/^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/.test(
        phone9,
      )
    ) {
      alert(translate.alert_phone[language])
      return
    }
    const phone10 = boolTel10
      ? document.querySelector('#vacancy-phone10')?.value.trim()
      : ''
    if (
      phone10 !== '' &&
      !/^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/.test(
        phone10,
      )
    ) {
      alert(translate.alert_phone[language])
      return
    }
    phones = [
      phone1,
      phone2,
      phone3,
      phone4,
      phone5,
      phone6,
      phone7,
      phone8,
      phone9,
      phone10,
    ]
    const phone = phones.filter((tel) => tel != '')
    const email = document.querySelector('#vacancy-email')?.value.trim() || ''
    if (email === '') {
      alert(translate.alert[language])
      console.log('alerttt')
      return
    }
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
      alert(translate.alert_email[language])
      return
    }
    const country = document.querySelector('#vacancy-country').value.trim()
    if (country === '') {
      alert(translate.alert[language])
      console.log('alerttt')
      return
    }
    const city = document.querySelector('#vacancy-city').value.trim()
    if (city === '') {
      alert(translate.alert[language])
      console.log('alerttt')
      return
    }
    const addr = document.querySelector('#vacancy-address').value.trim()
    if (addr === '') {
      alert(translate.alert[language])
      console.log('alerttt')
      return
    }
    const address = country + ' ' + city + ' ' + addr
    const uni1 = await document
        .querySelector('#vacancy-university1')
        ?.value.trim(),
      uni2 = await document.querySelector('#vacancy-university2')?.value.trim(),
      uni3 = await document.querySelector('#vacancy-university3')?.value.trim(),
      uni4 = await document.querySelector('#vacancy-university4')?.value.trim(),
      uni5 = await document.querySelector('#vacancy-university5')?.value.trim(),
      uni6 = await document.querySelector('#vacancy-university6')?.value.trim(),
      uni7 = await document.querySelector('#vacancy-university7')?.value.trim(),
      uni8 = await document.querySelector('#vacancy-university8')?.value.trim(),
      uni9 = await document.querySelector('#vacancy-university9')?.value.trim(),
      uni10 = await document
        .querySelector('#vacancy-university10')
        ?.value.trim()
    const faculty1 = await document
        .querySelector('#vacancy-faculty1')
        ?.value.trim(),
      faculty2 = await document
        .querySelector('#vacancy-faculty2')
        ?.value.trim(),
      faculty3 = await document
        .querySelector('#vacancy-faculty3')
        ?.value.trim(),
      faculty4 = await document
        .querySelector('#vacancy-faculty4')
        ?.value.trim(),
      faculty5 = await document
        .querySelector('#vacancy-faculty5')
        ?.value.trim(),
      faculty6 = await document
        .querySelector('#vacancy-faculty6')
        ?.value.trim(),
      faculty7 = await document
        .querySelector('#vacancy-faculty7')
        ?.value.trim(),
      faculty8 = await document
        .querySelector('#vacancy-faculty8')
        ?.value.trim(),
      faculty9 = await document
        .querySelector('#vacancy-faculty9')
        ?.value.trim(),
      faculty10 = await document
        .querySelector('#vacancy-faculty10')
        ?.value.trim()
    const language1 = document
        .querySelector('#vacancy-lang_study1')
        .value.trim(),
      language2 = document.querySelector('#vacancy-lang_study2')?.value.trim(),
      language3 = document.querySelector('#vacancy-lang_study3')?.value.trim(),
      language4 = document.querySelector('#vacancy-lang_study4')?.value.trim(),
      language5 = document.querySelector('#vacancy-lang_study5')?.value.trim(),
      language6 = document.querySelector('#vacancy-lang_study6')?.value.trim(),
      language7 = document.querySelector('#vacancy-lang_study7')?.value.trim(),
      language8 = document.querySelector('#vacancy-lang_study8')?.value.trim(),
      language9 = document.querySelector('#vacancy-lang_study9')?.value.trim(),
      language10 = document.querySelector('#vacancy-lang_study10')?.value.trim()

    if (
      uni1 === '' ||
      faculty1 === '' ||
      language1 === '' ||
      graduation1 === year
    ) {
      alert(translate.alert[language])
      console.log('alerttt')
      return
    }
    if (
      booledu2 &&
      (uni2 === '' ||
        faculty2 === '' ||
        language2 === '' ||
        graduation2 === year)
    ) {
      alert(translate.alert[language])
      console.log('alerttt')
      return
    }
    if (
      booledu3 &&
      (uni3 === '' ||
        faculty3 === '' ||
        language3 === '' ||
        graduation3 === year)
    ) {
      alert(translate.alert[language])
      console.log('alerttt')
      return
    }
    if (
      booledu4 &&
      (uni4 === '' ||
        faculty4 === '' ||
        language4 === '' ||
        graduation4 === year)
    ) {
      alert(translate.alert[language])
      console.log('alerttt')
      return
    }
    if (
      booledu5 &&
      (uni5 === '' ||
        faculty5 === '' ||
        language5 === '' ||
        graduation5 === year)
    ) {
      alert(translate.alert[language])
      console.log('alerttt')
      return
    }
    if (
      booledu6 &&
      (uni6 === '' ||
        faculty6 === '' ||
        language6 === '' ||
        graduation6 === year)
    ) {
      alert(translate.alert[language])
      console.log('alerttt')
      return
    }
    if (
      booledu7 &&
      (uni7 === '' ||
        faculty7 === '' ||
        language7 === '' ||
        graduation7 === year)
    ) {
      alert(translate.alert[language])
      console.log('alerttt')
      return
    }
    if (
      booledu8 &&
      (uni8 === '' ||
        faculty8 === '' ||
        language8 === '' ||
        graduation8 === year)
    ) {
      alert(translate.alert[language])
      console.log('alerttt')
      return
    }
    if (
      booledu9 &&
      (uni9 === '' ||
        faculty9 === '' ||
        language9 === '' ||
        graduation9 === year)
    ) {
      alert(translate.alert[language])
      console.log('alerttt')
      return
    }
    if (
      booledu10 &&
      (uni10 === '' ||
        faculty10 === '' ||
        language10 === '' ||
        graduation10 === year)
    ) {
      alert(translate.alert[language])
      console.log('alerttt')
      return
    }
    let education = [
      {
        university: uni1,
        faculty: faculty1,
        language: language1,
        graduationYear: graduation1,
      },
      booledu2 && {
        university: uni2,
        faculty: faculty2,
        language: language2,
        graduationYear: graduation2,
      },
      booledu3 && {
        university: uni3,
        faculty: faculty3,
        language: language3,
        graduationYear: graduation3,
      },
      booledu4 && {
        university: uni4,
        faculty: faculty4,
        language: language4,
        graduationYear: graduation4,
      },
      booledu5 && {
        university: uni5,
        faculty: faculty5,
        language: language5,
        graduationYear: graduation5,
      },
      booledu6 && {
        university: uni6,
        faculty: faculty6,
        language: language6,
        graduationYear: graduation6,
      },
      booledu7 && {
        university: uni7,
        faculty: faculty7,
        language: language7,
        graduationYear: graduation7,
      },
      booledu8 && {
        university: uni8,
        faculty: faculty8,
        language: language8,
        graduationYear: graduation8,
      },
      booledu9 && {
        university: uni9,
        faculty: faculty9,
        language: language9,
        graduationYear: graduation9,
      },
      booledu10 && {
        university: uni10,
        faculty: faculty10,
        language: language10,
        graduationYear: graduation10,
      },
    ]
    education = education.filter((item) => item !== false)
    const lang1 = await document.querySelector('#vacancy-lang1')?.value.trim()
    const lang2 = await document.querySelector('#vacancy-lang2')?.value.trim()
    const lang3 = await document.querySelector('#vacancy-lang3')?.value.trim()
    const lang4 = await document.querySelector('#vacancy-lang4')?.value.trim()
    const lang5 = await document.querySelector('#vacancy-lang5')?.value.trim()
    const lang6 = await document.querySelector('#vacancy-lang6')?.value.trim()
    const lang7 = await document.querySelector('#vacancy-lang7')?.value.trim()
    const lang8 = await document.querySelector('#vacancy-lang8')?.value.trim()
    const lang9 = await document.querySelector('#vacancy-lang9')?.value.trim()
    const lang10 = await document.querySelector('#work-lang10')?.value.trim()

    if (
      lang1 === '' ||
      reading1 === choose ||
      writing1 === choose ||
      speaking1 === choose ||
      listening1 === choose
    ) {
      alert(translate.alert[language])
      console.log('alerttt')
      return
    }
    if (
      boollang2 &&
      (lang2 === '' ||
        reading2 === choose ||
        writing2 === choose ||
        speaking2 === choose ||
        listening2 === choose)
    ) {
      alert(translate.alert[language])
      console.log('alerttt')
      return
    }
    if (
      boollang3 &&
      (lang3 === '' ||
        reading3 === choose ||
        writing3 === choose ||
        speaking3 === choose ||
        listening3 === choose)
    ) {
      alert(translate.alert[language])
      console.log('alerttt')
      return
    }
    if (
      boollang4 &&
      (lang4 === '' ||
        reading4 === choose ||
        writing4 === choose ||
        speaking4 === choose ||
        listening4 === choose)
    ) {
      alert(translate.alert[language])
      console.log('alerttt')
      return
    }
    if (
      boollang5 &&
      (lang5 === '' ||
        reading5 === choose ||
        writing5 === choose ||
        speaking5 === choose ||
        listening5 === choose)
    ) {
      alert(translate.alert[language])
      console.log('alerttt')
      return
    }
    if (
      boollang6 &&
      (lang6 === '' ||
        reading6 === choose ||
        writing6 === choose ||
        speaking6 === choose ||
        listening6 === choose)
    ) {
      alert(translate.alert[language])
      console.log('alerttt')
      return
    }
    if (
      boollang7 &&
      (lang7 === '' ||
        reading7 === choose ||
        writing7 === choose ||
        speaking7 === choose ||
        listening7 === choose)
    ) {
      alert(translate.alert[language])
      console.log('alerttt')
      return
    }
    if (
      boollang8 &&
      (lang8 === '' ||
        reading8 === choose ||
        writing8 === choose ||
        speaking8 === choose ||
        listening8 === choose)
    ) {
      alert(translate.alert[language])
      console.log('alerttt')
      return
    }
    if (
      boollang9 &&
      (lang9 === '' ||
        reading9 === choose ||
        writing9 === choose ||
        speaking9 === choose ||
        listening9 === choose)
    ) {
      alert(translate.alert[language])
      console.log('alerttt')
      return
    }
    if (
      boollang10 &&
      (lang10 === '' ||
        reading10 === choose ||
        writing10 === choose ||
        speaking10 === choose ||
        listening10 === choose)
    ) {
      alert(translate.alert[language])
      console.log('alerttt')
      return
    }
    let languageSkills = [
      {
        language: lang1,
        Reading: reading1,
        Writing: writing1,
        Speaking: speaking1,
        Listening: listening1,
      },
      boollang2 && {
        language: lang2,
        Reading: reading2,
        Writing: writing2,
        Speaking: speaking2,
        Listening: listening2,
      },
      boollang3 && {
        language: lang3,
        Reading: reading3,
        Writing: writing3,
        Speaking: speaking3,
        Listening: listening3,
      },
      boollang4 && {
        language: lang4,
        Reading: reading4,
        Writing: writing4,
        Speaking: speaking4,
        Listening: listening4,
      },
      boollang5 && {
        language: lang5,
        Reading: reading5,
        Writing: writing5,
        Speaking: speaking5,
        Listening: listening5,
      },
      boollang6 && {
        language: lang6,
        Reading: reading6,
        Writing: writing6,
        Speaking: speaking6,
        Listening: listening6,
      },
      boollang7 && {
        language: lang7,
        Reading: reading7,
        Writing: writing7,
        Speaking: speaking7,
        Listening: listening7,
      },
      boollang8 && {
        language: lang8,
        Reading: reading8,
        Writing: writing8,
        Speaking: speaking8,
        Listening: listening8,
      },
      boollang9 && {
        language: lang9,
        Reading: reading9,
        Writing: writing9,
        Speaking: speaking9,
        Listening: listening9,
      },
      boollang10 && {
        language: lang10,
        Reading: reading10,
        Writing: writing10,
        Speaking: speaking10,
        Listening: listening10,
      },
    ]
    languageSkills = languageSkills.filter((item) => item)
    const company = await document
      .querySelector('#vacancy-current-company')
      ?.value.trim()
    if (company === '') {
      alert(translate.alert[language])
      console.log('alerttt')
      return
    }
    const position = await document
      .querySelector('#vacancy-current-position')
      ?.value.trim()
    if (position === '') {
      alert(translate.alert[language])
      console.log('alerttt')
      return
    }
    const exp = await document
      .querySelector('#vacancy-general-experience')
      ?.value.trim()
    if (exp === '') {
      alert(translate.alert[language])
      console.log('alerttt')
      return
    }
    const field = await document
      .querySelector('#vacancy-relevant-field')
      ?.value.trim()
    if (field === '') {
      alert(translate.alert[language])
      console.log('alerttt')
      return
    }
    const experience = {
      company: company,
      position: position,
      generalExperience: exp,
      fieldExperience: field,
    }
    const note = document.querySelector('#vacancy-note')?.value.trim() || ''
    const skills = skillsList
      .filter((s) => s.name && s.name.trim() !== '')
      .map((s) => `${s.name.trim()} (${s.level || 'Orta'})`)
      .join(', ')

    if (!selectedImage) {
      alert(translate.alert_photo[language])
      return
    }
    if (!selectedFile) {
      alert(translate.alert_cv[language])
      return
    }

    let photoLocation = 'no image'
    let resumeLocation = 'no cv'

    if (selectedImage) {
      try {
        const imgRes = await fetch(`${config.API_URL}/s3Url`).then((res) => res.json())
        const uploadUrl = imgRes.url.startsWith('http') ? imgRes.url : `${config.API_URL}${imgRes.url}`
        await fetch(uploadUrl, {
          method: 'PUT',
          body: selectedImage,
        })
        photoLocation = imgRes.url.includes('.com/')
          ? imgRes.url.split('?')[0].split('.com/')[1]
          : imgRes.url.replace('/api/upload/', '')
      } catch (err) {
        console.error('Photo upload failed:', err)
      }
    }

    if (selectedFile) {
      try {
        const cvRes = await fetch(`${config.API_URL}/s3Url`).then((res) => res.json())
        const uploadUrl = cvRes.url.startsWith('http') ? cvRes.url : `${config.API_URL}${cvRes.url}`
        await fetch(uploadUrl, {
          method: 'PUT',
          body: selectedFile,
        })
        resumeLocation = cvRes.url.includes('.com/')
          ? cvRes.url.split('?')[0].split('.com/')[1]
          : cvRes.url.replace('/api/upload/', '')
      } catch (err) {
        console.error('CV upload failed:', err)
      }
    }

    const data = await {
      vacancy_id,
      vacancy_name,
      fullname,
      birth,
      gender,
      phone,
      email,
      address,
      education,
      languageSkills,
      experience,
      skills,
      photoLocation,
      resumeLocation,
      note,
    }
    const response = await VacancyAPI.insert(data)
    if (response.status === 200) {
      window.location.href = '/success/v1'
    }
  }
  return load ? (
    <>
      <section className={`${className} ${styles.container}`}>
        <Breadcrumb crumbs={crumbs} />
        <h2>
          <Account /> {translate.about[language]}
        </h2>
        <div className={styles.about}>
          <GeneralInput
            label={translate.fullname[language]}
            type="text"
            placeholder={translate.enter_fullname[language]}
            id="vacancy-fullname"
          />
          <div>
            <GeneralInput
              label={translate.date[language]}
              type="date"
              id="vacancy-date"
            />
          </div>
        </div>
        <div className={styles.email}>
          <GeneralInput
            label={translate.email[language]}
            type="text"
            id="vacancy-email"
            placeholder={translate.email_ph[language]}
            onInput={(e) => {
              setError(
                !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
                  e.target.value,
                ),
              )
            }}
            style={{
              border: error ? '1px solid red' : '1px solid #C5CEE0',
            }}
          />
        </div>
        <div className={styles.gender}>
          <div
            className={styles.select}
            onBlur={() =>
              setTimeout(function () {
                setIsVisible4(false)
              }, 250)
            }
          >
            <p>{translate.gender[language]}</p>
            <span tabIndex="1" onClick={() => setIsVisible4(true)}>
              {gender} <LangArrows />
            </span>
            <ul style={isVisible4 ? { display: 'block' } : { display: 'none' }}>
              {data.map((e) => (
                <li
                  onClick={() => {
                    setGender(e[language])
                  }}
                >
                  {e[language]}
                </li>
              ))}
            </ul>
          </div>
          <GeneralInput
            label={translate.phone[language]}
            type="tel"
            placeholder="+994 XX XXX XX XX"
            id="vacancy-phone1"
          />
          {boolTel2 ? (
            <div>
              <GeneralInput
                label={translate.phone[language]}
                type="tel"
                placeholder="+994 XX XXX XX XX"
                id="vacancy-phone2"
              />
              <Cancel onClick={() => setBoolTel2(false)} />
            </div>
          ) : null}
          {boolTel3 ? (
            <div>
              <GeneralInput
                label={translate.phone[language]}
                type="tel"
                placeholder="+994 XX XXX XX XX"
                id="vacancy-phone3"
              />
              <Cancel onClick={() => setBoolTel3(false)} />
            </div>
          ) : null}
          {boolTel4 ? (
            <div>
              <GeneralInput
                label={translate.phone[language]}
                type="tel"
                placeholder="+994 XX XXX XX XX"
                id="vacancy-phone4"
              />
              <Cancel onClick={() => setBoolTel4(false)} />
            </div>
          ) : null}
          {boolTel5 ? (
            <div>
              <GeneralInput
                label={translate.phone[language]}
                type="tel"
                placeholder="+994 XX XXX XX XX"
                id="vacancy-phone5"
              />
              <Cancel onClick={() => setBoolTel5(false)} />
            </div>
          ) : null}
          {boolTel6 ? (
            <div>
              <GeneralInput
                label={translate.phone[language]}
                type="tel"
                placeholder="+994 XX XXX XX XX"
                id="vacancy-phone6"
              />
              <Cancel onClick={() => setBoolTel6(false)} />
            </div>
          ) : null}
          {boolTel7 ? (
            <div>
              <GeneralInput
                label={translate.phone[language]}
                type="tel"
                placeholder="+994 XX XXX XX XX"
                id="vacancy-phone7"
              />
              <Cancel onClick={() => setBoolTel7(false)} />
            </div>
          ) : null}
          {boolTel8 ? (
            <div>
              <GeneralInput
                label={translate.phone[language]}
                type="tel"
                placeholder="+994 XX XXX XX XX"
                id="vacancy-phone8"
              />
              <Cancel onClick={() => setBoolTel8(false)} />
            </div>
          ) : null}
          {boolTel9 ? (
            <div>
              <GeneralInput
                label={translate.phone[language]}
                type="tel"
                placeholder="+994 XX XXX XX XX"
                id="vacancy-phone9"
              />
              <Cancel onClick={() => setBoolTel9(false)} />
            </div>
          ) : null}
          {boolTel10 ? (
            <div>
              <GeneralInput
                label={translate.phone[language]}
                type="tel"
                placeholder="+994 XX XXX XX XX"
                id="vacancy-phone10"
              />
              <Cancel onClick={() => setBoolTel10(false)} />
            </div>
          ) : null}
        </div>
        {!boolTel10 && (
          <button
            onClick={() => {
              addTel()
            }}
            className={styles.button}
          >
            <Plus /> {translate.add_tel[language]}
          </button>
        )}
        <h2>
          <Map /> {translate.current_address[language]}
        </h2>
        <div className={styles.address}>
          <GeneralInput
            label={translate.country[language]}
            type="text"
            placeholder={translate.enter_info[language]}
            id="vacancy-country"
          />
          <GeneralInput
            label={translate.city[language]}
            type="text"
            placeholder={translate.enter_info[language]}
            id="vacancy-city"
          />
          <GeneralInput
            label={translate.address[language]}
            type="text"
            placeholder={translate.enter_info[language]}
            id="vacancy-address"
          />
        </div>
        <h2>
          <Education /> {translate.education[language]}
          <span>({translate.edu_info[language]})</span>
        </h2>
        <div ref={eduRef} className={`education ${styles.education}`}>
          <div className={styles.edu}>
            <div>
              <GeneralInput
                label={translate.university[language]}
                type="text"
                placeholder={translate.enter_info[language]}
                id="vacancy-university1"
              />
              <GeneralInput
                label={translate.faculty[language]}
                type="text"
                placeholder={translate.enter_info[language]}
                id="vacancy-faculty1"
              />
            </div>
            <div>
              <GeneralInput
                label={translate.lang_study[language]}
                type="text"
                placeholder={translate.enter_info[language]}
                id="vacancy-lang_study1"
              />
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setEdu1(false)
                  }, 250)
                }
              >
                <p>{translate.gra_year[language]}</p>
                <span tabIndex="1" onClick={() => setEdu1(true)}>
                  {graduation1} <LangArrows />
                </span>
                <ul style={edu1 ? { display: 'block' } : { display: 'none' }}>
                  {graduations.map((e) => (
                    <li
                      onClick={() => {
                        setGraduation1(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          {booledu2 ? (
            <div className={styles.edu}>
              <div>
                <GeneralInput
                  label={translate.university[language]}
                  type="text"
                  placeholder={translate.enter_info[language]}
                  id="vacancy-university2"
                />
                <GeneralInput
                  label={translate.faculty[language]}
                  type="text"
                  placeholder={translate.enter_info[language]}
                  id="vacancy-faculty2"
                />
              </div>
              <div>
                <GeneralInput
                  label={translate.lang_study[language]}
                  type="text"
                  placeholder={translate.enter_info[language]}
                  id="vacancy-lang_study2"
                />
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setEdu2(false)
                    }, 250)
                  }
                >
                  <p>{translate.gra_year[language]}</p>
                  <span tabIndex="1" onClick={() => setEdu2(true)}>
                    {graduation2} <LangArrows />
                  </span>
                  <ul style={edu2 ? { display: 'block' } : { display: 'none' }}>
                    {graduations.map((e) => (
                      <li
                        onClick={() => {
                          setGraduation2(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <Cancel onClick={() => setBoolEdu2(false)} />
            </div>
          ) : null}
          {booledu3 ? (
            <div className={styles.edu}>
              <div>
                <GeneralInput
                  label={translate.university[language]}
                  type="text"
                  placeholder={translate.enter_info[language]}
                  id="vacancy-university3"
                />
                <GeneralInput
                  label={translate.faculty[language]}
                  type="text"
                  placeholder={translate.enter_info[language]}
                  id="vacancy-faculty3"
                />
              </div>
              <div>
                <GeneralInput
                  label={translate.lang_study[language]}
                  type="text"
                  placeholder={translate.enter_info[language]}
                  id="vacancy-lang_study3"
                />
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setEdu3(false)
                    }, 250)
                  }
                >
                  <p>{translate.gra_year[language]}</p>
                  <span tabIndex="1" onClick={() => setEdu3(true)}>
                    {graduation3} <LangArrows />
                  </span>
                  <ul style={edu3 ? { display: 'block' } : { display: 'none' }}>
                    {graduations.map((e) => (
                      <li
                        onClick={() => {
                          setGraduation3(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <Cancel onClick={() => setBoolEdu3(false)} />
            </div>
          ) : null}
          {booledu4 ? (
            <div className={styles.edu}>
              <div>
                <GeneralInput
                  label={translate.university[language]}
                  type="text"
                  placeholder={translate.enter_info[language]}
                  id="vacancy-university4"
                />
                <GeneralInput
                  label={translate.faculty[language]}
                  type="text"
                  placeholder={translate.enter_info[language]}
                  id="vacancy-faculty4"
                />
              </div>
              <div>
                <GeneralInput
                  label={translate.lang_study[language]}
                  type="text"
                  placeholder={translate.enter_info[language]}
                  id="vacancy-lang_study4"
                />
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setEdu4(false)
                    }, 250)
                  }
                >
                  <p>{translate.gra_year[language]}</p>
                  <span tabIndex="1" onClick={() => setEdu4(true)}>
                    {graduation4} <LangArrows />
                  </span>
                  <ul style={edu4 ? { display: 'block' } : { display: 'none' }}>
                    {graduations.map((e) => (
                      <li
                        onClick={() => {
                          setGraduation4(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <Cancel onClick={() => setBoolEdu4(false)} />
            </div>
          ) : null}
          {booledu5 ? (
            <div className={styles.edu}>
              <div>
                <GeneralInput
                  label={translate.university[language]}
                  type="text"
                  placeholder={translate.enter_info[language]}
                  id="vacancy-university5"
                />
                <GeneralInput
                  label={translate.faculty[language]}
                  type="text"
                  placeholder={translate.enter_info[language]}
                  id="vacancy-faculty5"
                />
              </div>
              <div>
                <GeneralInput
                  label={translate.lang_study[language]}
                  type="text"
                  placeholder={translate.enter_info[language]}
                  id="vacancy-lang_study5"
                />
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setEdu5(false)
                    }, 250)
                  }
                >
                  <p>{translate.gra_year[language]}</p>
                  <span tabIndex="1" onClick={() => setEdu5(true)}>
                    {graduation5} <LangArrows />
                  </span>
                  <ul style={edu5 ? { display: 'block' } : { display: 'none' }}>
                    {graduations.map((e) => (
                      <li
                        onClick={() => {
                          setGraduation5(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <Cancel onClick={() => setBoolEdu5(false)} />
            </div>
          ) : null}
          {booledu6 ? (
            <div className={styles.edu}>
              <div>
                <GeneralInput
                  label={translate.university[language]}
                  type="text"
                  placeholder={translate.enter_info[language]}
                  id="vacancy-university6"
                />
                <GeneralInput
                  label={translate.faculty[language]}
                  type="text"
                  placeholder={translate.enter_info[language]}
                  id="vacancy-faculty6"
                />
              </div>
              <div>
                <GeneralInput
                  label={translate.lang_study[language]}
                  type="text"
                  placeholder={translate.enter_info[language]}
                  id="vacancy-lang_study6"
                />
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setEdu6(false)
                    }, 250)
                  }
                >
                  <p>{translate.gra_year[language]}</p>
                  <span tabIndex="1" onClick={() => setEdu6(true)}>
                    {graduation6} <LangArrows />
                  </span>
                  <ul style={edu6 ? { display: 'block' } : { display: 'none' }}>
                    {graduations.map((e) => (
                      <li
                        onClick={() => {
                          setGraduation6(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <Cancel onClick={() => setBoolEdu6(false)} />
            </div>
          ) : null}
          {booledu7 ? (
            <div className={styles.edu}>
              <div>
                <GeneralInput
                  label={translate.university[language]}
                  type="text"
                  placeholder={translate.enter_info[language]}
                  id="vacancy-university7"
                />
                <GeneralInput
                  label={translate.faculty[language]}
                  type="text"
                  placeholder={translate.enter_info[language]}
                  id="vacancy-faculty7"
                />
              </div>
              <div>
                <GeneralInput
                  label={translate.lang_study[language]}
                  type="text"
                  placeholder={translate.enter_info[language]}
                  id="vacancy-lang_study7"
                />
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setEdu7(false)
                    }, 250)
                  }
                >
                  <p>{translate.gra_year[language]}</p>
                  <span tabIndex="1" onClick={() => setEdu7(true)}>
                    {graduation7} <LangArrows />
                  </span>
                  <ul style={edu7 ? { display: 'block' } : { display: 'none' }}>
                    {graduations.map((e) => (
                      <li
                        onClick={() => {
                          setGraduation7(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <Cancel onClick={() => setBoolEdu7(false)} />
            </div>
          ) : null}
          {booledu8 ? (
            <div className={styles.edu}>
              <div>
                <GeneralInput
                  label={translate.university[language]}
                  type="text"
                  placeholder={translate.enter_info[language]}
                  id="vacancy-university8"
                />
                <GeneralInput
                  label={translate.faculty[language]}
                  type="text"
                  placeholder={translate.enter_info[language]}
                  id="vacancy-faculty8"
                />
              </div>
              <div>
                <GeneralInput
                  label={translate.lang_study[language]}
                  type="text"
                  placeholder={translate.enter_info[language]}
                  id="vacancy-lang_study8"
                />
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setEdu8(false)
                    }, 250)
                  }
                >
                  <p>{translate.gra_year[language]}</p>
                  <span tabIndex="1" onClick={() => setEdu8(true)}>
                    {graduation8} <LangArrows />
                  </span>
                  <ul style={edu8 ? { display: 'block' } : { display: 'none' }}>
                    {graduations.map((e) => (
                      <li
                        onClick={() => {
                          setGraduation8(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <Cancel onClick={() => setBoolEdu8(false)} />
            </div>
          ) : null}
          {booledu9 ? (
            <div className={styles.edu}>
              <div>
                <GeneralInput
                  label={translate.university[language]}
                  type="text"
                  placeholder={translate.enter_info[language]}
                  id="vacancy-university9"
                />
                <GeneralInput
                  label={translate.faculty[language]}
                  type="text"
                  placeholder={translate.enter_info[language]}
                  id="vacancy-faculty9"
                />
              </div>
              <div>
                <GeneralInput
                  label={translate.lang_study[language]}
                  type="text"
                  placeholder={translate.enter_info[language]}
                  id="vacancy-lang_study9"
                />
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setEdu9(false)
                    }, 250)
                  }
                >
                  <p>{translate.gra_year[language]}</p>
                  <span tabIndex="1" onClick={() => setEdu9(true)}>
                    {graduation9} <LangArrows />
                  </span>
                  <ul style={edu9 ? { display: 'block' } : { display: 'none' }}>
                    {graduations.map((e) => (
                      <li
                        onClick={() => {
                          setGraduation9(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <Cancel onClick={() => setBoolEdu9(false)} />
            </div>
          ) : null}
          {booledu10 ? (
            <div className={styles.edu}>
              <div>
                <GeneralInput
                  label={translate.university[language]}
                  type="text"
                  placeholder={translate.enter_info[language]}
                  id="vacancy-university10"
                />
                <GeneralInput
                  label={translate.faculty[language]}
                  type="text"
                  placeholder={translate.enter_info[language]}
                  id="vacancy-faculty10"
                />
              </div>
              <div>
                <GeneralInput
                  label={translate.lang_study[language]}
                  type="text"
                  placeholder={translate.enter_info[language]}
                  id="vacancy-lang_study10"
                />
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setEdu10(false)
                    }, 250)
                  }
                >
                  <p>{translate.gra_year[language]}</p>
                  <span tabIndex="1" onClick={() => setEdu10(true)}>
                    {graduation10} <LangArrows />
                  </span>
                  <ul
                    style={edu10 ? { display: 'block' } : { display: 'none' }}
                  >
                    {graduations.map((e) => (
                      <li
                        onClick={() => {
                          setGraduation10(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <Cancel onClick={() => setBoolEdu10(false)} />
            </div>
          ) : null}
        </div>
        {!booledu10 && (
          <button
            onClick={() => {
              addEdu()
            }}
            className={styles.button}
          >
            <Plus /> {translate.add_edu[language]}
          </button>
        )}
        <h2>
          <Language /> {translate.lang_skills[language]}
          <span>({translate.lang_info[language]})</span>
        </h2>
        <div className={styles.language}>
          <div className={styles.lang}>
            <GeneralInput
              label={translate.language[language]}
              type="text"
              placeholder={translate.enter_lang[language]}
              id="vacancy-lang1"
            />
            <div
              className={styles.select}
              onBlur={() =>
                setTimeout(function () {
                  setreadBool1(false)
                }, 250)
              }
            >
              <p>{translate.reading[language]}</p>
              <span tabIndex="1" onClick={() => setreadBool1(true)}>
                {reading1} <LangArrows />
              </span>
              <ul
                style={readBool1 ? { display: 'block' } : { display: 'none' }}
              >
                {percents.map((e) => (
                  <li
                    onClick={() => {
                      setReading1(e)
                    }}
                  >
                    {e}
                  </li>
                ))}
              </ul>
            </div>
            <div
              className={styles.select}
              onBlur={() =>
                setTimeout(function () {
                  setwritingBool1(false)
                }, 250)
              }
            >
              <p>{translate.writing[language]}</p>
              <span tabIndex="1" onClick={() => setwritingBool1(true)}>
                {writing1} <LangArrows />
              </span>
              <ul
                style={
                  writingBool1 ? { display: 'block' } : { display: 'none' }
                }
              >
                {percents.map((e) => (
                  <li
                    onClick={() => {
                      setwriting1(e)
                    }}
                  >
                    {e}
                  </li>
                ))}
              </ul>
            </div>
            <div
              className={styles.select}
              onBlur={() =>
                setTimeout(function () {
                  setspeakingBool1(false)
                }, 250)
              }
            >
              <p>{translate.speaking[language]}</p>
              <span tabIndex="1" onClick={() => setspeakingBool1(true)}>
                {speaking1} <LangArrows />
              </span>
              <ul
                style={
                  speakingBool1 ? { display: 'block' } : { display: 'none' }
                }
              >
                {percents.map((e) => (
                  <li
                    onClick={() => {
                      setspeaking1(e)
                    }}
                  >
                    {e}
                  </li>
                ))}
              </ul>
            </div>
            <div
              className={styles.select}
              onBlur={() =>
                setTimeout(function () {
                  setlisteningBool1(false)
                }, 250)
              }
            >
              <p>{translate.listening[language]}</p>
              <span tabIndex="1" onClick={() => setlisteningBool1(true)}>
                {listening1} <LangArrows />
              </span>
              <ul
                style={
                  listeningBool1 ? { display: 'block' } : { display: 'none' }
                }
              >
                {percents.map((e) => (
                  <li
                    onClick={() => {
                      setlistening1(e)
                    }}
                  >
                    {e}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          {boollang2 ? (
            <div className={styles.lang}>
              <GeneralInput
                label={translate.language[language]}
                type="text"
                placeholder={translate.enter_lang[language]}
                id="vacancy-lang2"
              />
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setreadBool2(false)
                  }, 250)
                }
              >
                <p>{translate.reading[language]}</p>
                <span tabIndex="1" onClick={() => setreadBool2(true)}>
                  {reading2} <LangArrows />
                </span>
                <ul
                  style={readBool2 ? { display: 'block' } : { display: 'none' }}
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setReading2(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setwritingBool2(false)
                  }, 250)
                }
              >
                <p>{translate.writing[language]}</p>
                <span tabIndex="1" onClick={() => setwritingBool2(true)}>
                  {writing2} <LangArrows />
                </span>
                <ul
                  style={
                    writingBool2 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setwriting2(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setspeakingBool2(false)
                  }, 250)
                }
              >
                <p>{translate.speaking[language]}</p>
                <span tabIndex="1" onClick={() => setspeakingBool2(true)}>
                  {speaking2} <LangArrows />
                </span>
                <ul
                  style={
                    speakingBool2 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setspeaking2(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setlisteningBool2(false)
                  }, 250)
                }
              >
                <p>{translate.listening[language]}</p>
                <span tabIndex="1" onClick={() => setlisteningBool2(true)}>
                  {listening2} <LangArrows />
                </span>
                <ul
                  style={
                    listeningBool2 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setlistening2(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <Cancel onClick={() => setBoollang2(false)} />
            </div>
          ) : null}
          {boollang3 ? (
            <div className={styles.lang}>
              <GeneralInput
                label={translate.language[language]}
                type="text"
                placeholder={translate.enter_lang[language]}
                id="vacancy-lang3"
              />
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setreadBool3(false)
                  }, 250)
                }
              >
                <p>{translate.reading[language]}</p>
                <span tabIndex="1" onClick={() => setreadBool3(true)}>
                  {reading3} <LangArrows />
                </span>
                <ul
                  style={readBool3 ? { display: 'block' } : { display: 'none' }}
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setReading3(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setwritingBool3(false)
                  }, 250)
                }
              >
                <p>{translate.writing[language]}</p>
                <span tabIndex="1" onClick={() => setwritingBool3(true)}>
                  {writing3} <LangArrows />
                </span>
                <ul
                  style={
                    writingBool3 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setwriting3(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setspeakingBool3(false)
                  }, 250)
                }
              >
                <p>{translate.speaking[language]}</p>
                <span tabIndex="1" onClick={() => setspeakingBool3(true)}>
                  {speaking3} <LangArrows />
                </span>
                <ul
                  style={
                    speakingBool3 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setspeaking3(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setlisteningBool3(false)
                  }, 250)
                }
              >
                <p>{translate.listening[language]}</p>
                <span tabIndex="1" onClick={() => setlisteningBool3(true)}>
                  {listening3} <LangArrows />
                </span>
                <ul
                  style={
                    listeningBool3 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setlistening3(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <Cancel onClick={() => setBoollang3(false)} />
            </div>
          ) : null}
          {boollang4 ? (
            <div className={styles.lang}>
              <GeneralInput
                label={translate.language[language]}
                type="text"
                placeholder={translate.enter_lang[language]}
                id="vacancy-lang4"
              />
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setreadBool4(false)
                  }, 250)
                }
              >
                <p>{translate.reading[language]}</p>
                <span tabIndex="1" onClick={() => setreadBool4(true)}>
                  {reading4} <LangArrows />
                </span>
                <ul
                  style={readBool4 ? { display: 'block' } : { display: 'none' }}
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setReading4(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setwritingBool4(false)
                  }, 250)
                }
              >
                <p>{translate.writing[language]}</p>
                <span tabIndex="1" onClick={() => setwritingBool4(true)}>
                  {writing4} <LangArrows />
                </span>
                <ul
                  style={
                    writingBool4 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setwriting4(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setspeakingBool4(false)
                  }, 250)
                }
              >
                <p>{translate.speaking[language]}</p>
                <span tabIndex="1" onClick={() => setspeakingBool4(true)}>
                  {speaking4} <LangArrows />
                </span>
                <ul
                  style={
                    speakingBool4 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setspeaking4(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setlisteningBool4(false)
                  }, 250)
                }
              >
                <p>{translate.listening[language]}</p>
                <span tabIndex="1" onClick={() => setlisteningBool4(true)}>
                  {listening4} <LangArrows />
                </span>
                <ul
                  style={
                    listeningBool4 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setlistening4(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <Cancel onClick={() => setBoollang4(false)} />
            </div>
          ) : null}
          {boollang5 ? (
            <div className={styles.lang}>
              <GeneralInput
                label={translate.language[language]}
                type="text"
                placeholder={translate.enter_lang[language]}
                id="vacancy-lang5"
              />
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setreadBool5(false)
                  }, 250)
                }
              >
                <p>{translate.reading[language]}</p>
                <span tabIndex="1" onClick={() => setreadBool5(true)}>
                  {reading5} <LangArrows />
                </span>
                <ul
                  style={readBool5 ? { display: 'block' } : { display: 'none' }}
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setReading5(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setwritingBool5(false)
                  }, 250)
                }
              >
                <p>{translate.writing[language]}</p>
                <span tabIndex="1" onClick={() => setwritingBool5(true)}>
                  {writing5} <LangArrows />
                </span>
                <ul
                  style={
                    writingBool5 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setwriting5(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setspeakingBool5(false)
                  }, 250)
                }
              >
                <p>{translate.speaking[language]}</p>
                <span tabIndex="1" onClick={() => setspeakingBool5(true)}>
                  {speaking5} <LangArrows />
                </span>
                <ul
                  style={
                    speakingBool5 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setspeaking5(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setlisteningBool5(false)
                  }, 250)
                }
              >
                <p>{translate.listening[language]}</p>
                <span tabIndex="1" onClick={() => setlisteningBool5(true)}>
                  {listening5} <LangArrows />
                </span>
                <ul
                  style={
                    listeningBool5 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setlistening5(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <Cancel onClick={() => setBoollang5(false)} />
            </div>
          ) : null}
          {boollang6 ? (
            <div className={styles.lang}>
              <GeneralInput
                label={translate.language[language]}
                type="text"
                placeholder={translate.enter_lang[language]}
                id="vacancy-lang6"
              />
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setreadBool6(false)
                  }, 250)
                }
              >
                <p>{translate.reading[language]}</p>
                <span tabIndex="1" onClick={() => setreadBool6(true)}>
                  {reading6} <LangArrows />
                </span>
                <ul
                  style={readBool6 ? { display: 'block' } : { display: 'none' }}
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setReading6(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setwritingBool6(false)
                  }, 250)
                }
              >
                <p>{translate.writing[language]}</p>
                <span tabIndex="1" onClick={() => setwritingBool6(true)}>
                  {writing6} <LangArrows />
                </span>
                <ul
                  style={
                    writingBool6 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setwriting6(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setspeakingBool6(false)
                  }, 250)
                }
              >
                <p>{translate.speaking[language]}</p>
                <span tabIndex="1" onClick={() => setspeakingBool6(true)}>
                  {speaking6} <LangArrows />
                </span>
                <ul
                  style={
                    speakingBool6 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setspeaking6(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setlisteningBool6(false)
                  }, 250)
                }
              >
                <p>{translate.listening[language]}</p>
                <span tabIndex="1" onClick={() => setlisteningBool6(true)}>
                  {listening6} <LangArrows />
                </span>
                <ul
                  style={
                    listeningBool6 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setlistening6(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <Cancel onClick={() => setBoollang6(false)} />
            </div>
          ) : null}
          {boollang7 ? (
            <div className={styles.lang}>
              <GeneralInput
                label={translate.language[language]}
                type="text"
                placeholder={translate.enter_lang[language]}
                id="vacancy-lang7"
              />
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setreadBool7(false)
                  }, 250)
                }
              >
                <p>{translate.reading[language]}</p>
                <span tabIndex="1" onClick={() => setreadBool7(true)}>
                  {reading7} <LangArrows />
                </span>
                <ul
                  style={readBool7 ? { display: 'block' } : { display: 'none' }}
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setReading7(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setwritingBool7(false)
                  }, 250)
                }
              >
                <p>{translate.writing[language]}</p>
                <span tabIndex="1" onClick={() => setwritingBool7(true)}>
                  {writing7} <LangArrows />
                </span>
                <ul
                  style={
                    writingBool7 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setwriting7(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setspeakingBool7(false)
                  }, 250)
                }
              >
                <p>{translate.speaking[language]}</p>
                <span tabIndex="1" onClick={() => setspeakingBool7(true)}>
                  {speaking7} <LangArrows />
                </span>
                <ul
                  style={
                    speakingBool7 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setspeaking7(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setlisteningBool7(false)
                  }, 250)
                }
              >
                <p>{translate.listening[language]}</p>
                <span tabIndex="1" onClick={() => setlisteningBool7(true)}>
                  {listening7} <LangArrows />
                </span>
                <ul
                  style={
                    listeningBool7 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setlistening7(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <Cancel onClick={() => setBoollang7(false)} />
            </div>
          ) : null}
          {boollang8 ? (
            <div className={styles.lang}>
              <GeneralInput
                label={translate.language[language]}
                type="text"
                placeholder={translate.enter_lang[language]}
                id="vacancy-lang8"
              />
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setreadBool8(false)
                  }, 250)
                }
              >
                <p>{translate.reading[language]}</p>
                <span tabIndex="1" onClick={() => setreadBool8(true)}>
                  {reading8} <LangArrows />
                </span>
                <ul
                  style={readBool8 ? { display: 'block' } : { display: 'none' }}
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setReading8(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setwritingBool8(false)
                  }, 250)
                }
              >
                <p>{translate.writing[language]}</p>
                <span tabIndex="1" onClick={() => setwritingBool8(true)}>
                  {writing8} <LangArrows />
                </span>
                <ul
                  style={
                    writingBool8 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setwriting8(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setspeakingBool8(false)
                  }, 250)
                }
              >
                <p>{translate.speaking[language]}</p>
                <span tabIndex="1" onClick={() => setspeakingBool8(true)}>
                  {speaking8} <LangArrows />
                </span>
                <ul
                  style={
                    speakingBool8 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setspeaking8(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setlisteningBool8(false)
                  }, 250)
                }
              >
                <p>{translate.listening[language]}</p>
                <span tabIndex="1" onClick={() => setlisteningBool8(true)}>
                  {listening8} <LangArrows />
                </span>
                <ul
                  style={
                    listeningBool8 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setlistening8(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <Cancel onClick={() => setBoollang8(false)} />
            </div>
          ) : null}
          {boollang9 ? (
            <div className={styles.lang}>
              <GeneralInput
                label={translate.language[language]}
                type="text"
                placeholder={translate.enter_lang[language]}
                id="vacancy-lang9"
              />
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setreadBool9(false)
                  }, 250)
                }
              >
                <p>{translate.reading[language]}</p>
                <span tabIndex="1" onClick={() => setreadBool9(true)}>
                  {reading9} <LangArrows />
                </span>
                <ul
                  style={readBool9 ? { display: 'block' } : { display: 'none' }}
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setReading9(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setwritingBool9(false)
                  }, 250)
                }
              >
                <p>{translate.writing[language]}</p>
                <span tabIndex="1" onClick={() => setwritingBool9(true)}>
                  {writing9} <LangArrows />
                </span>
                <ul
                  style={
                    writingBool9 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setwriting9(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setspeakingBool9(false)
                  }, 250)
                }
              >
                <p>{translate.speaking[language]}</p>
                <span tabIndex="1" onClick={() => setspeakingBool9(true)}>
                  {speaking9} <LangArrows />
                </span>
                <ul
                  style={
                    speakingBool9 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setspeaking9(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setlisteningBool9(false)
                  }, 250)
                }
              >
                <p>{translate.listening[language]}</p>
                <span tabIndex="1" onClick={() => setlisteningBool9(true)}>
                  {listening9} <LangArrows />
                </span>
                <ul
                  style={
                    listeningBool9 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setlistening9(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <Cancel onClick={() => setBoollang9(false)} />
            </div>
          ) : null}
          {boollang10 ? (
            <div className={styles.lang}>
              <GeneralInput
                label={translate.language[language]}
                type="text"
                placeholder={translate.enter_lang[language]}
                id="vacancy-lang10"
              />
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setreadBool10(false)
                  }, 250)
                }
              >
                <p>{translate.reading[language]}</p>
                <span tabIndex="1" onClick={() => setreadBool10(true)}>
                  {reading10} <LangArrows />
                </span>
                <ul
                  style={
                    readBool10 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setReading10(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setwritingBool10(false)
                  }, 250)
                }
              >
                <p>{translate.writing[language]}</p>
                <span tabIndex="1" onClick={() => setwritingBool10(true)}>
                  {writing10} <LangArrows />
                </span>
                <ul
                  style={
                    writingBool10 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setwriting10(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setspeakingBool10(false)
                  }, 250)
                }
              >
                <p>{translate.speaking[language]}</p>
                <span tabIndex="1" onClick={() => setspeakingBool10(true)}>
                  {speaking10} <LangArrows />
                </span>
                <ul
                  style={
                    speakingBool10 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setspeaking10(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setlisteningBool10(false)
                  }, 250)
                }
              >
                <p>{translate.listening[language]}</p>
                <span tabIndex="1" onClick={() => setlisteningBool10(true)}>
                  {listening10} <LangArrows />
                </span>
                <ul
                  style={
                    listeningBool10 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setlistening10(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <Cancel onClick={() => setBoollang10(false)} />
            </div>
          ) : null}
        </div>
        {!boollang10 && (
          <button
            onClick={() => {
              addLang()
            }}
            className={styles.button}
          >
            <Plus /> {translate.add_lang[language]}
          </button>
        )}
        <h2>
          <Work /> {language === 'AZ' ? 'Bacarıqlar' : language === 'TR' ? 'Yetenekler ve Beceriler' : language === 'RU' ? 'Профессиональные навыки' : 'Professional Skills'}
          <span>({language === 'AZ' ? 'əgər bacarığınız yoxdursa, boş buraxın' : language === 'TR' ? 'yoksa boş bırakabilirsiniz' : 'optional'})</span>
        </h2>
        <div className={styles.skillsWrapper}>
          {skillsList.map((skill) => (
            <div key={skill.id} className={styles.skillRow}>
              <GeneralInput
                label={language === 'AZ' ? 'Bacarığın adı' : language === 'TR' ? 'Beceri Adı' : language === 'RU' ? 'Название навыка' : 'Skill Name'}
                type="text"
                placeholder={
                  language === 'AZ'
                    ? 'Məsələn: 1C 8.3, BTP, Excel, Vergi Məcəlləsi...'
                    : language === 'TR'
                    ? 'Örneğin: 1C, Excel, Logo, Vergi Mevzuatı...'
                    : language === 'RU'
                    ? 'Например: 1C 8.3, BTP, Excel, Налоговый кодекс...'
                    : 'E.g.: 1C 8.3, BTP, Excel, Tax Code...'
                }
                value={skill.name}
                onInput={(e) => updateSkillName(skill.id, e.target.value)}
              />
              <div
                className={styles.skillSelect}
                onBlur={() =>
                  setTimeout(function () {
                    setSkillsList((prev) =>
                      prev.map((s) => (s.id === skill.id ? { ...s, bool: false } : s))
                    )
                  }, 250)
                }
              >
                <p>{language === 'AZ' ? 'Səviyyə' : language === 'TR' ? 'Seviye' : language === 'RU' ? 'Уровень' : 'Level'}</p>
                <span tabIndex="1" onClick={() => toggleSkillDropdown(skill.id)}>
                  {skill.level} <LangArrows />
                </span>
                <ul style={skill.bool ? { display: 'block' } : { display: 'none' }}>
                  {skillLevels.map((lvl, lidx) => (
                    <li
                      key={lidx}
                      onClick={() => updateSkillLevel(skill.id, lvl[language] || lvl.TR || lvl.AZ)}
                    >
                      {lvl[language] || lvl.TR || lvl.AZ}
                    </li>
                  ))}
                </ul>
              </div>
              <Cancel className={styles.skillCancel} onClick={() => removeSkill(skill.id)} />
            </div>
          ))}
        </div>
        <button
          type="button"
          onClick={addSkill}
          className={styles.button}
          style={{ marginBottom: '40px' }}
        >
          <Plus /> {language === 'AZ' ? 'Yeni bacarıq əlavə edin' : language === 'TR' ? 'Yeni beceri ekleyin' : language === 'RU' ? 'Добавить новый навык' : 'Add new skill'}
        </button>
        <h2>
          <Work /> {translate.experience[language]}
          <span>({translate.work_info[language]})</span>
        </h2>
        <div className={styles.experience}>
          <GeneralInput
            label={translate.current_company[language]}
            type="text"
            placeholder={translate.enter_company[language]}
            id="vacancy-current-company"
          />
          <GeneralInput
            label={translate.current_position[language]}
            type="text"
            placeholder={translate.enter_position[language]}
            id="vacancy-current-position"
          />
          <GeneralInput
            label={translate.general_experience[language]}
            type="text"
            placeholder={translate.eg1[language]}
            id="vacancy-general-experience"
          />
          <GeneralInput
            label={translate.relevant_field[language]}
            type="text"
            placeholder={translate.eg2[language]}
            id="vacancy-relevant-field"
          />
        </div>
        <div className={styles.uploads}>
          <div>
            {selectedImage ? (
              <div className={styles.loaded}>
                <span>{translate.upload_photo[language]}</span>
                <p>{Helper.textLengthChecker(selectedImage.name, 18)}</p>
                <Close
                  onClick={() => {
                    setSelectedImage(null)
                  }}
                />
              </div>
            ) : (
              <div className={styles.simple}>
                <span>{translate.upload_photo[language]}</span>
                {translate.max_upload[language]}
              </div>
            )}

            <input
              type="button"
              value={translate.upload[language]}
              onClick={() => {
                document.getElementById('file').click()
              }}
            />
            <input
              id="file"
              style={{ display: 'none' }}
              type="file"
              name="myImage"
              onChange={(event) => {
                setSelectedImage(
                  event.target.files[0].size < 1048576
                    ? event.target.files[0]
                    : null,
                )
              }}
            />
          </div>
        </div>
        <div className={styles.cvUploadSection}>
          <h3>{translate.upload_resume[language] || 'CV / Rezüme'}</h3>
          <div
            className={`${styles.dropZone} ${dragActive ? styles.dragActive : ''} ${selectedFile ? styles.hasFile : ''}`}
            onDragOver={(e) => {
              e.preventDefault()
              e.stopPropagation()
              setDragActive(true)
            }}
            onDragLeave={(e) => {
              e.preventDefault()
              e.stopPropagation()
              setDragActive(false)
            }}
            onDrop={(e) => {
              e.preventDefault()
              e.stopPropagation()
              setDragActive(false)
              if (e.dataTransfer.files && e.dataTransfer.files[0]) {
                const file = e.dataTransfer.files[0]
                if (file.size <= 10 * 1024 * 1024) {
                  setSelectedFile(file)
                } else {
                  alert(language === 'AZ' ? 'Faylın həcmi 10 MB-dan çox olmamalıdır' : 'File must be under 10MB')
                }
              }
            }}
            onClick={() => {
              if (!selectedFile) {
                document.getElementById('file2').click()
              }
            }}
          >
            {selectedFile ? (
              <div className={styles.filePreview}>
                <div className={styles.fileIcon}>📄</div>
                <div className={styles.fileMeta}>
                  <strong>{selectedFile.name}</strong>
                  <span>{((selectedFile.size || 0) / 1024 / 1024).toFixed(2)} MB • {language === 'AZ' ? 'Hazırdır' : 'Ready'}</span>
                </div>
                <button
                  type="button"
                  className={styles.removeFileBtn}
                  onClick={(e) => {
                    e.stopPropagation()
                    setSelectedFile(null)
                  }}
                  title={language === 'AZ' ? 'Faylı sil' : 'Remove file'}
                >
                  ✕
                </button>
              </div>
            ) : (
              <div className={styles.emptyPrompt}>
                <div className={styles.uploadIcon}>📁</div>
                <p>
                  <strong>{translate.upload_resume[language] || 'CV / Rezüme yükləyin'}</strong>:
                  <span> {language === 'AZ' ? 'Faylı bura sürükləyin və ya kompüterdən seçin' : 'Drag & drop or browse'}</span>
                </p>
                <small>PDF, DOC, DOCX (Maks. 10 MB)</small>
              </div>
            )}
          </div>
          <input
            id="file2"
            style={{ display: 'none' }}
            type="file"
            accept=".pdf,.doc,.docx"
            name="myPdf"
            onChange={(event) => {
              if (event.target.files && event.target.files[0]) {
                setSelectedFile(event.target.files[0])
              }
            }}
          />
        </div>
        <div className={styles.textarea}>
          <p>{translate.note[language]}</p>
          <span>{translate.not_required[language]}</span>
          <textarea
            id="vacancy-note"
            placeholder={translate.write_note[language]}
          ></textarea>
        </div>
        <FormButton type="button" onClick={sendAppeal}>
          {translate.apply[language]}
        </FormButton>
      </section>
    </>
  ) : (
    <Loading />
  )
}

export default VacancyApply
